import { render, staticRenderFns } from "./JsonKeyValueEditor.vue?vue&type=template&id=6129b47e&scoped=true&"
import script from "./JsonKeyValueEditor.vue?vue&type=script&lang=js&"
export * from "./JsonKeyValueEditor.vue?vue&type=script&lang=js&"
import style0 from "./JsonKeyValueEditor.vue?vue&type=style&index=0&id=6129b47e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6129b47e",
  null
  
)

export default component.exports